export default "__VITE_ASSET__CcZQSQOm__"